import { MutableRefObject, useCallback, useEffect } from 'react'

export const useLoadMoreOnScroll = <T extends HTMLElement>(
  ref: MutableRefObject<T | null>,
  fetchNextPage: () => void,
  hasNextPage: boolean,
  isFetching: boolean,
  disabled?: boolean
): void => {
  const handleObserver = useCallback(
    (entries: IntersectionObserverEntry[]) => {
      const [target] = entries
      if (target?.isIntersecting && hasNextPage && !isFetching && !disabled) {
        fetchNextPage()
      }
    },
    [fetchNextPage, hasNextPage, isFetching, disabled]
  )

  useEffect(() => {
    if (ref.current) {
      const element = ref.current
      const observer = new IntersectionObserver(handleObserver, { threshold: 0 })
      observer.observe(element)
      return () => observer.unobserve(element)
    }
    return undefined
  }, [fetchNextPage, hasNextPage, handleObserver, ref])
}
